import './App.css';
import React from 'react';
import { Routes, Route, Outlet, Navigate } from "react-router-dom"
import Box from '@mui/material/Box';
import WelcomeLayout from './layouts/WelcomeLayout';
import Layout from './layouts/MainLayout';
import Login from './pages/Login'
import ChatPage from './pages/ChatPage'
import DataPage from './pages/DataPage';
import MyGoogleMap from './pages/MyGoogleMap';
import MapContainer from './pages/MapContainer';
import GeniePage from './pages/GeniePage';
import WelcomePage from './pages/WelcomePage';
import Map2Page from './pages/Map2Page';
import TransmissionPage from './pages/TransmissionPage';
import AgentAssistantPage from './pages/AgentAssistantPage';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setRedirectUrl } from './store/features/authSlice';

const App = () => {
  const dispatch = useDispatch()
  const location = useLocation();
  const from = location.pathname

  if(from !== "/")
    dispatch(setRedirectUrl(from))

  return (
    <Box className="App">
      <Routes>
        <Route path="/" element={<WelcomeLayout><Login /></WelcomeLayout>} />
        <Route path="/home" element={<Layout headerTitle='Chatbot' ><WelcomePage /></Layout>} />
        <Route path="/login" element={<Navigate to="/" />} />
        <Route path="/map" element={<MapContainer />}>
          <Route index element={<Navigate to="/map/index" replace />} />
          <Route path="/map/index" element={<MyGoogleMap />} />
        </Route>
        <Route path="/map2" element={<Layout headerTitle='Map2'><Map2Page /></Layout>} />
        <Route path="/farm" element={<Layout headerTitle='FieldOps Chatbot' ><ChatPage /> </Layout>} />
        <Route path="/data" element={<Layout headerTitle='Data Chatbot' ><DataPage /> </Layout>} />
        <Route path="/genie" element={<Layout headerTitle='Data Chatbot' ><GeniePage /> </Layout>} />
        <Route path="/job-assistant" element={<Layout headerTitle='Job Assistant' ><AgentAssistantPage /> </Layout>} />

        <Route 
          path="/transmission" 
          element={
            <Layout headerTitle='Driveline QA AI Assistant' 
              subtitle='Driveline QA AI Assistant will help with test report data analysis, diagnosis suggestion and transmission related question answering. Please start with uploading a test report!' >
              <TransmissionPage /> 
            </Layout>} />
        {/* <Route path="*" element={<Navigate to="/data" />} /> */}
      </Routes>
      <Outlet />
    </Box>
  );
}

export default App;
